module.exports = __webpack_public_path__ + "static/media/Upload.8a3cae0d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/EditPooch/Upload.svg
// module id = 345
// module chunks = 0